import React, { useCallback, useContext, useEffect } from 'react'

import API from '../../../../../services/api'
import ClientDropdown from '../../../../organisms/client-dropdown/ClientDropdown'
import Banner from '../../../../atoms/banner/Banner'
import DisplayField from '../../../../atoms/form/display-field/DisplayField'
import Input from '../../../../atoms/form/input/Input'
import Form, { FormRequiredText } from '../../../../atoms/form/Form'
import VerticalGroup from '../../../../atoms/verticalgroup/VerticalGroup'
import { SimulationContext } from '../../context'
import useForm from '../../../../../hooks/useForm'
import RoundDropdown from '../../../../organisms/round-dropdown/RoundDropdown'


const General: React.FC<{}> = () => {
  const { config, updateConfig, assignOnSubmitFunction, updateFormStatus } = useContext(SimulationContext)
  let [{ formData: {name, clientIds, rounds}, fieldErrors, error, inProgress, formUpdated }, { setField, setDropdownField, setMultiSelectField, handleSubmit }] = useForm(config?.generalSetup ? {
    ...config.generalSetup
  } : {
    name: '',
    clientIds: [],
    rounds: 3
  })

  const onSubmit = useCallback(async () => {
    const payload: API.SimulationCreateRequest = {
      name: name.trim(),
      clientIds,
      rounds
    }
    const response = config?.id
      ? await API.editSimulation(config.id, { generalSetup: payload })
      : await API.createSimulation(payload)

    updateConfig(response)
    return response
  }, [name, clientIds, rounds, config?.id, updateConfig])

  const validate = useCallback(() => {
    const errors = []
    if (!name) {
      errors.push({ field: 'name', message: 'Enter a name' })
    }

    if (!clientIds.length) {
      errors.push({ field: 'clientIds', message: 'Please select at least one client' })
    }

    return errors
  }, [name, clientIds])

  useEffect(() => {
    assignOnSubmitFunction(handleSubmit(onSubmit, validate))
  }, [assignOnSubmitFunction, handleSubmit, onSubmit, validate])

  useEffect(() => {
    updateFormStatus({
      inProgress: inProgress,
      formUpdated: formUpdated
    })
  }, [updateFormStatus, inProgress, formUpdated])

  return (
    <div className="step-container">
      <VerticalGroup spread full>
        <VerticalGroup wide>
          <Banner type='error' active={!!error} message={error?.message}/>
          <Form id='simulation-add-form'>
            <h3>General Settings</h3>
            <FormRequiredText />
            <Input autoFocus data-test='name' type='text' label='Simulation name *' value={name} onChange={setField('name')} error={fieldErrors.name} />
            <ClientDropdown label='Select Clients *' isMulti clientIds={clientIds} onChange={setMultiSelectField('clientIds')} error={fieldErrors.clientIds} />
            <RoundDropdown
              label="Number of Rounds"
              value={rounds}
              onChange={setDropdownField('rounds')}
            />
            {!!config && <DisplayField label='Simulation ID' value={config.id} />}
          </Form>
        </VerticalGroup>
      </VerticalGroup>
    </div>
  )
}

export { default as GeneralDisplay } from './Display'
export default General
